import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import {
  getIdleTimeDataService,
  updateIdleTimeService,
} from "../../services/IdleTimeService";
import { IdleTime, IdleTimeState } from "../../interfaces/idle-time-interface";

export const getIdleTimeData = createAsyncThunk(
  "idleTime/getIdleTimeData",
  async (_, thunkAPI) => {
    const token = localStorage.getItem("idToken");

    if (!token) {
      return thunkAPI.rejectWithValue("No authentication token found.");
    }

    try {
      const response = await getIdleTimeDataService();
      console.log(response.data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateIdleTime = createAsyncThunk(
  "idleTime/updateIdleTime",
  async (data: { idleTime: number; updatedBy: string }, thunkAPI) => {
    const token = localStorage.getItem("idToken");

    if (!token) {
      return thunkAPI.rejectWithValue("No authentication token found.");
    }

    try {
      const response = await updateIdleTimeService(data);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Failed to update idle time");
    }
  }
);

const idleTimeSlice = createSlice({
  name: "idleTime",
  initialState: {
    idleTime: { minutes: 3 } as IdleTime,
    status: "idle",
    error: null,
  } as IdleTimeState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getIdleTimeData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        getIdleTimeData.fulfilled,
        (state, action: PayloadAction<IdleTime>) => {
          state.status = "succeeded";
          state.idleTime = action.payload;
        }
      )
      .addCase(getIdleTimeData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })
      .addCase(updateIdleTime.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        updateIdleTime.fulfilled,
        (state, action: PayloadAction<IdleTime>) => {
          state.status = "succeeded";
          state.idleTime = action.payload;
        }
      )
      .addCase(updateIdleTime.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export const idleTimeReducer = idleTimeSlice.reducer;
